import { get, post, patch, del } from './apiClient';

// Types
export interface Question {
  id: string;
  user_id?: string;
  job_id?: string;
  label: string;
  group: string;
  is_active: boolean;
  sort_order: number;
  weight?: number;
}

export interface QuestionCreateDTO {
  label: string;
  group: string;
  is_active?: boolean;
  sort_order: number;
}

export interface QuestionUpdateDTO {
  label?: string;
  group?: string;
  is_active?: boolean;
  sort_order?: number;
}

// API functions
export const questionsApi = {
  // Get active questions for the current user
  getActiveQuestions: async (): Promise<Question[]> => {
    return get<Question[]>('/questions');
  },

  // Get all questions created by users in the current user's organization
  getOrganizationQuestions: async (): Promise<Question[]> => {
    return get<Question[]>('/questions/organization');
  },

  // Get a specific question by ID
  getById: async (questionId: string): Promise<Question> => {
    return get<Question>(`/questions/${questionId}`);
  },

  // Get questions for a specific job from form API
  getByJobId: async (jobId: string): Promise<Question[]> => {
    // Use direct fetch for external API instead of the get function
    const response = await fetch(`https://form.helloaura.net/questions/job/${jobId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include'
    });
    
    if (!response.ok) {
      throw new Error(`Failed to fetch questions: ${response.status}`);
    }
    
    return response.json();
  },

  // Create a new question
  create: async (questionData: QuestionCreateDTO): Promise<Question> => {
    return post<Question>('/questions/', questionData);
  },

  // Update a question
  update: async (questionId: string, questionData: QuestionUpdateDTO): Promise<Question> => {
    return patch<Question>(`/questions/${questionId}`, questionData);
  },

  // Delete a question
  delete: async (questionId: string): Promise<void> => {
    return del<void>(`/questions/${questionId}`);
  }
};